// 주요 키워드 정의
export const KEYWORDS = {
    "Action": /Action:\s*(\w+)/,
    "PPG/ACC": /PPG\/ACC:\s*(\w+)/,
    "Battery": /Battery:\s*L\s*([-\d]+)%\s*R\s*([-\d]+)%/,
    "BLE": /BLE:\s*(\w+)/,
    "ANC": /ANC(?:\(.*?\))?:.*?(OFF|STRONG|ANC_OFF)/,
    "RSSI": /RSSI:\s*(-?\d+)/,
    "Sound": /Sound\(.*?\):\s*BGM\((true|false)\)\s*dbbeats\((true|false)\)\s*stimulus\((true|false)\)/,
    "Earbud": /Earbud:\s*(.+)/,
    "RoleSwitch": /RoleSwitch:\s*(?:Optional\(")?(\w+)(?:"\))?\s*->\s*(?:Optional\(")?(\w+)(?:"\))?/,
    "SleepStage": /SleepStage:\s*(?:Optional\()?(\d+)/,
};

export const Y_AXIS_TICKS = {
    "Sound_BGM": [0, 1],
    "Sound_dbbeats": [0, 1],
    "Sound_stimulus": [0, 1],
    "Battery_L": [0, 20, 40, 60, 80, 100],
    "Battery_R": [0, 20, 40, 60, 80, 100],
};

export const Y_AXIS_TICK_LABELS = {
    "Sound_BGM": ["on", "off"],
    "Sound_dbbeats": ["on", "off"],
    "Sound_stimulus": ["off", "on"],
    "Battery_L": [0, 20, 40, 60, 80, 100],
    "Battery_R": [0, 20, 40, 60, 80, 100],
};

// 시간 파싱 함수
export const parseTime = (line) => {
    const timeStr = line.substring(0, 23);
    const formats = [
        /(\d{4})-(\d{2})-(\d{2}) (\d{2}):(\d{2}):(\d{2})\.(\d{3})/,
        /(\d{4})-(\d{2})-(\d{2}) (\d{2}):(\d{2}):(\d{2}):(\d{3})/
    ];
    
    for (let format of formats) {
        const match = timeStr.match(format);
        if (match) {
            const [, year, month, day, hour, minute, second, ms] = match;
            return new Date(year, month - 1, day, hour, minute, second, ms);
        }
    }
    return null;
}

// 로그 파싱 함수
export const parseLogFile = (content) => {
    const data = {};
    const lines = content.split('\n');
    
    for (let line of lines) {
        if (!line.includes(':')) continue;
        
        const timestamp = parseTime(line);
        if (!timestamp) continue;
        
        for (let [key, pattern] of Object.entries(KEYWORDS)) {
            const match = line.match(pattern);
            if (match) {
                if (key === "Battery") {
                    if (!data["Battery_L"]) data["Battery_L"] = [];
                    if (!data["Battery_R"]) data["Battery_R"] = [];
                    data["Battery_L"].push({ x: timestamp, y: parseInt(match[1]) });
                    data["Battery_R"].push({ x: timestamp, y: parseInt(match[2]) });
                } else if (key === "Sound") {
                    if (!data["Sound_BGM"]) data["Sound_BGM"] = [];
                    if (!data["Sound_dbbeats"]) data["Sound_dbbeats"] = [];
                    if (!data["Sound_stimulus"]) data["Sound_stimulus"] = [];
                    data["Sound_BGM"].push({ x: timestamp, y: match[1] === "true" ? 1 : 0 });
                    data["Sound_dbbeats"].push({ x: timestamp, y: match[2] === "true" ? 1 : 0 });
                    data["Sound_stimulus"].push({ x: timestamp, y: match[3] === "true" ? 1 : 0 });
                } else if (key === "RoleSwitch") {
                    if (!data["RoleSwitch"]) data["RoleSwitch"] = [];
                    data["RoleSwitch"].push({ x: timestamp, y: `${match[1]} -> ${match[2]}` });
                } else {
                    if (!data[key]) data[key] = [];
                    const value = match.length > 1 ? match[1] : match[0];
                    data[key].push({ x: timestamp, y: isNaN(value) ? value : parseFloat(value) });
                    if (key === 'Earbud') console.log(value);
                }
                break;
            }
        }
    }
    console.log(data);
    return data;
}
